// Versicherter Versand (CHF 3.95) standaard aan, zonder app.
// Zodra er producten in de winkelwagen zitten wordt het verzekeringsproduct toegevoegd.
// Haalt de klant de regel zelf weg, dan wordt dat in het cart-attribuut _insured_shipping
// ("removed") onthouden en voegen we hem voor deze winkelwagen niet opnieuw toe.
(() => {
  const variantId = Number(window.insuredShippingVariantId);
  if (!variantId || window.__insuredShippingDefault) return;
  window.__insuredShippingDefault = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const stateKey = "_insured_shipping";
  const originalFetch = window.fetch.bind(window);
  let busy = false;
  let queued = false;
  let lastSeen = null; // was de verzekering bij de vorige check in de winkelwagen?

  const post = (path, body) =>
    originalFetch(`${root}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });

  const refresh = () => {
    if (typeof window.upcartRefreshCart === "function") window.upcartRefreshCart();
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  };

  async function check() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;

    try {
      const cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
      const line = cart.items.find((item) => item.variant_id === variantId);
      const hasProducts = cart.items.some((item) => item.variant_id !== variantId);
      let choice = cart.attributes && cart.attributes[stateKey];
      let changed = false;

      // Klant heeft de regel zelf verwijderd terwijl er nog producten in zitten: onthouden.
      if (lastSeen === true && !line && hasProducts && choice !== "removed") {
        await post("cart/update.js", { attributes: { [stateKey]: "removed" } });
        choice = "removed";
      }

      if (hasProducts && !line && choice !== "removed") {
        await post("cart/add.js", { items: [{ id: variantId, quantity: 1 }] });
        await post("cart/update.js", { attributes: { [stateKey]: "added" } });
        changed = true;
      } else if (line && !hasProducts) {
        // Niet alleen de verzekering in een verder lege winkelwagen laten staan.
        await post("cart/change.js", { id: line.key, quantity: 0 });
        changed = true;
      } else if (line && line.quantity > 1) {
        await post("cart/change.js", { id: line.key, quantity: 1 });
        changed = true;
      }

      lastSeen = changed ? hasProducts : Boolean(line);
      const qty = cart.items.filter((item) => item.variant_id !== variantId).reduce((a, item) => a + item.quantity, 0);
      window.__insuredShippingState = { on: changed ? hasProducts : Boolean(line), hasProducts, qty };
      renderToggles();
      if (changed) refresh();
    } catch (e) {
      console.error(e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        setTimeout(check, 300);
      }
    }
  }

  const isCartChange = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));

  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input && input.url;
    const request = originalFetch(input, init);
    if (isCartChange(url)) request.then(() => setTimeout(check, 300)).catch(() => {});
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartChange(url)) this.addEventListener("loadend", () => setTimeout(check, 300));
    return originalOpen.apply(this, arguments);
  };

  // UpCart wijzigt de winkelwagen ook via zijn eigen client; zijn hooks laten weten wanneer.
  ["upcartOnCartLoaded", "upcartOnCartUpdated", "upcartOnAddToCart"].forEach((name) => {
    const previous = window[name];
    window[name] = function () {
      setTimeout(check, 300);
      if (typeof previous === "function") return previous.apply(this, arguments);
    };
  });

  // ---- Schuifknop in de UpCart-winkelwagen; de productregel zelf wordt verborgen ----
  const HANDLE = "versicherter-versand";
  const CSS = `
    li.upcart-internal-cart-item:has(a[href*="/products/${HANDLE}"]) { display: none !important; }
    .bb-ins { display:flex; align-items:center; gap:12px; padding:12px 16px; margin:0 0 10px; border:1px solid #e3e3e3; border-radius:10px; background:#f7faf8; font-family:inherit; }
    .bb-ins__icon { width:30px; height:30px; flex:none; }
    .bb-ins__txt { flex:1; min-width:0; line-height:1.3; }
    .bb-ins__title { display:block; font-size:14px; font-weight:600; color:#1c1c1c; }
    .bb-ins__sub { display:block; font-size:12px; color:#666; }
    .bb-ins__price { font-size:14px; font-weight:600; color:#1c1c1c; white-space:nowrap; }
    .bb-ins__switch { position:relative; width:44px; height:24px; flex:none; cursor:pointer; }
    .bb-ins__switch input { opacity:0; width:0; height:0; position:absolute; }
    .bb-ins__slider { position:absolute; inset:0; background:#c9c9c9; border-radius:24px; transition:background .2s; }
    .bb-ins__slider:before { content:""; position:absolute; width:18px; height:18px; left:3px; top:3px; background:#fff; border-radius:50%; transition:transform .2s; box-shadow:0 1px 2px rgba(0,0,0,.25); }
    .bb-ins__switch input:checked + .bb-ins__slider { background:#1f7a4d; }
    .bb-ins__switch input:checked + .bb-ins__slider:before { transform:translateX(20px); }
    .bb-ins.is-busy { opacity:.6; pointer-events:none; }
  `;
  const ICON = '<svg class="bb-ins__icon" viewBox="0 0 24 24"><path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z" fill="#1f7a4d"/><path d="M8 12.2l2.6 2.6L16 9.4" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  async function setInsurance(on) {
    const cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
    const line = cart.items.find((item) => item.variant_id === variantId);
    await post("cart/update.js", { attributes: { [stateKey]: on ? "added" : "removed" } });
    if (on && !line) await post("cart/add.js", { items: [{ id: variantId, quantity: 1 }] });
    if (!on && line) await post("cart/change.js", { id: line.key, quantity: 0 });
    lastSeen = on;
    window.__insuredShippingState = Object.assign({}, window.__insuredShippingState, { on, hasProducts: true });
    refresh();
    setTimeout(check, 600);
  }

  function renderToggles() {
    const state = window.__insuredShippingState || { on: false, hasProducts: false };
    const host = document.getElementById("upCart");
    const sr = host && host.shadowRoot;
    if (!sr) return;
    if (!sr.getElementById("bb-ins-style")) {
      const st = document.createElement("style");
      st.id = "bb-ins-style";
      st.textContent = CSS;
      sr.appendChild(st);
    }
    const summary = sr.querySelector('[class*="Footer__cartSummarySection"]');
    let box = sr.getElementById("bb-ins");
    if (!state.hasProducts || !summary) {
      if (box) box.remove();
      return;
    }
    if (!box || box.nextElementSibling !== summary) {
      if (box) box.remove();
      box = document.createElement("div");
      box.id = "bb-ins";
      box.className = "bb-ins";
      box.innerHTML = `${ICON}<span class="bb-ins__txt"><span class="bb-ins__title">Versicherter Versand</span><span class="bb-ins__sub">Schutz bei Verlust, Beschädigung oder Diebstahl</span></span><span class="bb-ins__price">CHF 3.95</span><label class="bb-ins__switch"><input type="checkbox" aria-label="Versicherter Versand"><span class="bb-ins__slider"></span></label>`;
      box.querySelector("input").addEventListener("change", async (e) => {
        box.classList.add("is-busy");
        try { await setInsurance(e.target.checked); } finally { box.classList.remove("is-busy"); }
      });
      summary.parentNode.insertBefore(box, summary);
    }
    const input = box.querySelector("input");
    if (input.checked !== state.on) input.checked = state.on;
    fixCounts(sr);
  }

  // Tellers ("Cart • 2", het bolletje bij het winkelwagen-icoon) tonen alleen echte producten.
  function fixCounts(sr) {
    const qty = (window.__insuredShippingState || {}).qty;
    if (typeof qty !== "number") return;
    sr.querySelectorAll("h1, h2, h3, h4, span, div").forEach((el) => {
      if (el.children.length || el.closest("#bb-ins")) return;
      const m = el.textContent.match(/^(.*[•·]\s*)(\d+)\s*$/);
      if (m && Number(m[2]) !== qty) el.textContent = m[1] + qty;
    });
    document.querySelectorAll(".cart-count-bubble span[aria-hidden]").forEach((el) => {
      if (el.textContent.trim() !== String(qty)) el.textContent = String(qty);
    });
  }

  // UpCart rendert zijn inhoud steeds opnieuw: bij elke wijziging opnieuw plaatsen.
  const watch = () => {
    const host = document.getElementById("upCart");
    if (!host || !host.shadowRoot) return setTimeout(watch, 500);
    new MutationObserver(() => {
      clearTimeout(watch.t);
      watch.t = setTimeout(() => {
        renderToggles();
      }, 50);
    }).observe(host.shadowRoot, { childList: true, subtree: true });
    renderToggles();
  };
  watch();

  check();
})();
